export default "/kiban/_next/static/images/fpcSurfacePutData-7c3ffc1a2d45e17b615137c42e3c282c.png";